import { Message } from './Message'

export interface Command {
  id: string
  name: string
}

export interface CommandHandler {
  handleCommand(command: Message<Command>, callback: (error: Error) => void): void
}
